import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { splitManualSuffix } from "../../utils/reasonTaxClass";
import { REASON_NA } from "@/constants/constants";
import { useTripReasons } from "@/hooks/logbook/useTripReasons";

interface Props {
  value: string[];
  onChange: (reasons: string[]) => void;
}

/** Trip reason filter including "N/A" for trips without a reason; suffixes are stripped. */
export function ReasonMultiSelect({ value, onChange }: Props) {
  const { t } = useTranslation();
  const { data: reasons = [], isLoading } = useTripReasons();
  const options = useMemo(() => {
    const cleaned = new Set<string>();
    for (const reason of reasons) {
      const { reason: clean } = splitManualSuffix(reason);
      if (clean) cleaned.add(clean);
    }
    return [REASON_NA, ...cleaned];
  }, [reasons]);

  return (
    <Autocomplete
      id="logbook-audit-reasons"
      multiple
      size="small"
      fullWidth
      limitTags={1}
      disableCloseOnSelect
      loading={isLoading}
      options={options}
      value={value}
      getOptionLabel={option => (option === REASON_NA ? t("logbookAudit.grid.missingReason") : option)}
      onChange={(_, next) => onChange(next)}
      renderInput={params => (
        <TextField {...params} label={t("logbookAudit.filters.reason")} placeholder={t("logbookAudit.filters.reasonPlaceholder")} />
      )}
    />
  );
}
